import React, { useState } from 'react';
import { Heart, Gift, ArrowRight, Copy, Check, MessageCircle } from 'lucide-react';
import { Button } from './ui/button';
import BookingCalendar from './BookingCalendar';

const SHARE_MSG = `Treat the special woman in your life! Get 5% off any massage at Dublin Holistic Massage with code TREATHER.\n\nBook here: https://www.dublinholisticmassages.com`;

const TreatHerPromo = () => {
  const [copied, setCopied] = useState(false);
  const [bookingOpen, setBookingOpen] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText('TREATHER');
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <>
      <section className="py-16 bg-gradient-to-br from-rose-50 via-pink-50 to-rose-100 relative overflow-hidden" data-testid="treat-her-promo">
        <div className="absolute top-0 right-0 w-80 h-80 bg-rose-200/30 rounded-full blur-3xl" />
        <div className="absolute bottom-0 left-0 w-64 h-64 bg-pink-200/30 rounded-full blur-3xl" />

        <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 relative">
          <div className="grid md:grid-cols-2 gap-10 items-center">
            <div>
              <div className="inline-flex items-center gap-2 bg-rose-100 text-rose-600 px-4 py-1.5 rounded-full text-xs font-semibold uppercase tracking-wider mb-6">
                <Heart size={14} className="fill-rose-500 text-rose-500" />
                Special Offer
              </div>

              <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-stone-800 mb-4 leading-tight">
                Treat the Special
                <span className="block italic text-rose-500 mt-1">Woman in Your Life</span>
              </h2>

              <p className="text-stone-600 font-light mb-6 max-w-md leading-relaxed">
                Surprise her with the gift of relaxation. Whether it's your partner, mother, sister, or best friend
                — give her an experience she truly deserves. Use code <strong className="text-rose-600">TREATHER</strong> for 5% off.
              </p>

              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 mb-6">
                <div className="bg-white rounded-2xl border-2 border-dashed border-rose-300 px-6 py-3 flex items-center gap-3">
                  <Gift size={20} className="text-rose-500" />
                  <span className="font-mono text-xl font-bold tracking-widest text-rose-600">TREATHER</span>
                  <button
                    onClick={handleCopy}
                    className="ml-2 text-rose-400 hover:text-rose-600 transition-colors"
                    data-testid="copy-treather-btn"
                  >
                    {copied ? <Check size={18} className="text-green-500" /> : <Copy size={18} />}
                  </button>
                </div>
                <span className="text-2xl font-bold text-rose-500">5% OFF</span>
              </div>

              <div className="flex items-center gap-3">
                <Button
                  onClick={() => setBookingOpen(true)}
                  className="bg-rose-500 hover:bg-rose-600 text-white rounded-full py-6 px-8 text-sm uppercase tracking-wider font-medium group transition-all"
                  data-testid="treat-her-book-btn"
                >
                  Book for Her
                  <ArrowRight size={16} className="ml-2 group-hover:translate-x-1 transition-transform" />
                </Button>
                <Button
                  onClick={() => window.open(`https://wa.me/?text=${encodeURIComponent(SHARE_MSG)}`, '_blank')}
                  className="bg-luxury-green-600 hover:bg-luxury-green-500 text-white rounded-full w-12 h-12 p-0 flex items-center justify-center"
                  data-testid="treat-her-whatsapp-share"
                >
                  <MessageCircle size={20} />
                </Button>
              </div>
            </div>

            <div className="relative hidden md:block">
              <div className="bg-gradient-to-br from-rose-200 to-pink-200 rounded-3xl p-8 text-center">
                <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-8 shadow-lg">
                  <Heart size={48} className="text-rose-500 mx-auto mb-4 fill-rose-100" />
                  <h3 className="font-display text-2xl text-stone-800 mb-2">The Perfect Gift</h3>
                  <p className="text-stone-500 text-sm mb-4">A moment of pure relaxation she'll never forget</p>
                  <div className="bg-rose-50 rounded-xl p-4 text-left space-y-2">
                    <div className="flex items-center gap-2 text-sm text-stone-600">
                      <Check size={14} className="text-rose-500" />
                      <span>Choose any massage treatment</span>
                    </div>
                    <div className="flex items-center gap-2 text-sm text-stone-600">
                      <Check size={14} className="text-rose-500" />
                      <span>5% off with code TREATHER</span>
                    </div>
                    <div className="flex items-center gap-2 text-sm text-stone-600">
                      <Check size={14} className="text-rose-500" />
                      <span>Complimentary Nagomi wellness drink</span>
                    </div>
                    <div className="flex items-center gap-2 text-sm text-stone-600">
                      <Check size={14} className="text-rose-500" />
                      <span>Also available as a Gift Voucher</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <BookingCalendar isOpen={bookingOpen} onClose={() => setBookingOpen(false)} />
    </>
  );
};

export default TreatHerPromo;
